/* import __COLOCATED_TEMPLATE__ from './field-input-text.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { validateCharacterInput, validateFieldInput } from '../utils/validation';
import * as Format from '../utils/format';
import { tracked } from '@glimmer/tracking';

interface FieldInputTextArgs {
  isValid: string;
  fieldType: string;
  fieldId: string;
  formatString: string[];
  onInputChanged: (arg0: { fieldId: string; fieldValue: string; status: boolean }) => void;
}

export default class FieldInputText extends Component<FieldInputTextArgs> {
  @tracked charValid = true;
  @tracked fieldValid = true;

  get invalid(): boolean {
    return !this.args.isValid || !this.charValid;
  }

  // This function validates the character input during key up event.
  validateCharValue(value: string): void {
    this.charValid = validateCharacterInput(value.toString(), this.args.fieldType);
  }

  // Event Handler Function when the contents of the Textbox have changed, usually via Enter or Blur
  @action onValueChanged(event: { target: { value: string } }): void {
    let value = event.target.value;
    this.fieldValid = validateFieldInput(value, this.args.fieldType);
    if (this.fieldValid) {
      // Need to canonicalize
      value = Format.formatFieldValue(value, this.args.fieldType, this.args.formatString);
      event.target.value = value;
      this.charValid = true;
    }
    // Send Action to Parent Component (if provided)
    if (this.args.onInputChanged) {
      this.args.onInputChanged({ fieldId: this.args.fieldId, fieldValue: value, status: this.fieldValid });
    }
  }

  // Event Handler for Key Up
  // Input: event - object passed when a keyup event occurs
  @action onKeyUp(event: { key: string; ctrlKey: boolean; altKey: boolean; target: { value: string } }): void {
    // There are a number of events that we need to check up here
    // 1. Regular Key Strokes
    // 2. When the user presses Backspace
    // 3. When the user presses Delete
    // 4. Paste Event (Ctrl + V)
    // 5. Cut Event (Ctrl + X)
    // 6. Redo Event (Ctrl + Y)
    // 7. Undo Event (Ctrl + Z)
    const key = event.key.toUpperCase();
    const isCtrlPressed = event.ctrlKey;
    const isAltPressed = event.altKey;
    const value = event.target.value;
    if (key.length > 1) {
      switch (key) {
        case 'BACKSPACE':
        case 'DELETE':
          // Backspace or Delete
          if (value.length > 0) {
            this.validateCharValue(value);
          }
          break;
        default:
          break;
      }
    } else {
      if (isCtrlPressed) {
        switch (key) {
          case 'V': // Paste Event
          case 'X': // Cut Event
          case 'Y': // Redo Event
          case 'Z': // Undo Event
            if (value.length > 0) {
              this.validateCharValue(value);
            }
            break;
          default:
            break;
        }
      } else if (isAltPressed) {
        switch (key) {
          default:
            // Currently we will do nothing
            break;
        }
      } else {
        // Regular Key Strokes
        this.validateCharValue(value);
      }
    }
  }
}
